<template>
  <modal
    @close="$emit('close')"
    @neutralButtonClick="$emit('close')"
    @positiveButtonClick="save"
    :neutralButtonText="$t('action.cancel')"
    :positiveButtonText="$t('action.save')"
    :title="$t('campaignDesigner.targetDefinition.bookmarking.bookmark')">

    <Input
      :label="$t('campaignDesigner.targetDefinition.bookmarking.bookmarkName')"
      :validation="['required']"
      ref="bookmark_name"
      v-model="name" />
  </modal>
</template>
<script>
import EventBus from '../../../utils/EventBus'
import { getErrorMessage, validate } from '../../../utils/utils'
import Input from '../../../slds/Input'
import Modal from '../../../Modal'
import { mapActions } from 'vuex'
export default {
  props: {
    bookmark: {
      type: Object,
      default: () => {},
      required: true
    },
    scope: {
      type: String,
      default: '',
      required: true
    }
  },
  components: {
    Input,
    Modal
  },
  data () {
    return {
      name: ''
    }
  },
  created () {
    this.name = this.bookmark.segmentName
  },
  methods: {
    ...mapActions({
      saveBookmark: 'salesQueryBuilder/saveBookmark'
    }),
    async save () {
      const valid = validate(this, 'bookmark_', true)

      if (valid) {
        try {
          const payload = {
            name: this.name,
            section: {
              ...this.bookmark,
              segmentName: this.name
            },
            scope: this.scope,
            sfmcId: this.$store.getters['session/userId']
          }
          await this.saveBookmark(payload)
          this.showToast('success', this.$t('general.success'), 'text', this.$t('message.create'))
          this.$emit('close')
          EventBus.$emit('bookmark-added')
        } catch (error) {
          this.showToast('error', this.$t('general.error'), 'text', getErrorMessage(error))
        }
      }
    }
  }
}
</script>
